import SidebarBookingsSummaryModifyRoute from 'uplisting-frontend/pods/-sidebar/bookings/summary/modify/route';

export default class ProtectionOverviewBookingsSummaryModifyRoute extends SidebarBookingsSummaryModifyRoute {
  parentRoute = 'protection.overview.bookings';
  summaryRoute = 'protection.overview.bookings.summary';
}
